import React from "react";
import { useNavigate } from "react-router-dom";
import "./Services.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faServer,
  faBlog,
  faCloud,
  faGlobe,
  faShieldHalved,
  faEnvelope,
} from "@fortawesome/free-solid-svg-icons";

const Services = () => {
  const navigate = useNavigate();

  const services = [
    {
      id: "shared-hosting",
      icon: faServer,
      title: "Shared & cPanel hosting",
      desc:
        "Cost-effective Linux hosting with SSD storage, one-click apps, and easy control-panel management for sites and small stores.",
    },
    {
      id: "wordpress-hosting",
      icon: faBlog,
      title: "Managed WordPress",
      desc:
        "Optimized stack for WordPress with caching-friendly setup, staging options, and guidance on plugins and performance.",
    },
    {
      id: "vps-hosting",
      icon: faCloud,
      title: "VPS & cloud servers",
      desc:
        "Dedicated resources and root access when you outgrow shared hosting — ideal for apps, APIs, and high-traffic sites.",
    },
    {
      id: "domain-registration",
      icon: faGlobe,
      title: "Domains & DNS",
      desc:
        "Register and transfer domains with reliable DNS management, subdomains, and help pointing records to your hosting.",
    },
    {
      id: "ssl-security",
      icon: faShieldHalved,
      title: "SSL & security",
      desc:
        "Free and premium SSL options, malware scanning add-ons, and firewall-friendly configurations for safer sites.",
    },
    {
      id: "email-hosting",
      icon: faEnvelope,
      title: "Professional email",
      desc:
        "Branded email on your domain with webmail, forwarding, and spam protection — integrated with your hosting plan.",
    },
  ];

  return (
    <section className="about-services" aria-label="Hosting services">
      <div className="about-services-wrap">
        <header className="about-services-head">
          <h2>Hosting built for speed and peace of mind</h2>
          <p>
            From your first domain to a full VPS, we offer clear plans, honest
            specs, and help with DNS, SSL, and migrations — so you stay focused
            on your business, not server chores.
          </p>
        </header>

        <div className="about-services-list">
          {services.map((s) => (
            <article
              key={s.id}
              className="about-services-item"
              onClick={() => navigate(`/services/${s.id}`)}
              tabIndex={0}
              role="button"
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  navigate(`/services/${s.id}`);
                }
              }}
            >
              <div className="about-services-icon">
                <FontAwesomeIcon icon={s.icon} />
              </div>

              <div className="about-services-content">
                <h3>{s.title}</h3>
                <p>{s.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
